export default <T extends {}>(params: T): T => params;
